// SPDX-License-Identifier: AGPL-3.0-or-later

import type {UserSettingsTabType} from '@app/features/user/components/settings_utils/SettingsSectionRegistry';

export const PROFILE_SETTINGS_TAB: UserSettingsTabType = 'my_profile';
export const ACCOUNT_SETTINGS_TAB: UserSettingsTabType = 'account_security';

export const ACCOUNT_NESTED_TAB_TYPES = [
	'privacy_safety',
	'authorized_apps',
	'blocked_users',
	'devices',
] as const satisfies ReadonlyArray<UserSettingsTabType>;
export type AccountNestedSettingsTabType = (typeof ACCOUNT_NESTED_TAB_TYPES)[number];

export const ACCOUNT_NAVIGATION_TAB_TYPES = [
	ACCOUNT_SETTINGS_TAB,
	...ACCOUNT_NESTED_TAB_TYPES,
] as const satisfies ReadonlyArray<UserSettingsTabType>;

export const PRIMARY_SETTINGS_NAV_HIDDEN_TAB_TYPES = new Set<UserSettingsTabType>([
	PROFILE_SETTINGS_TAB,
	...ACCOUNT_NESTED_TAB_TYPES,
]);

export function isAccountNestedSettingsTab(
	tabType: UserSettingsTabType | null | undefined,
): tabType is AccountNestedSettingsTabType {
	return ACCOUNT_NESTED_TAB_TYPES.some((candidate) => candidate === tabType);
}

export function isAccountNavigationSettingsTab(tabType: UserSettingsTabType | null | undefined): boolean {
	return ACCOUNT_NAVIGATION_TAB_TYPES.some((candidate) => candidate === tabType);
}
